import type { EmailActivity } from '@common/types/activities';
import { Box, Typography } from '@mui/material';
import ShowLessButton from '../ShowLessButton';
import { cleanHTML } from '../util';

interface Props {
    emailBody: EmailActivity['body'];
    isBodyExpanded: boolean;
    setIsBodyExpanded: (val: boolean) => void;
}

export default function LawyerDeclineEmailBody({
    emailBody,
    isBodyExpanded,
    setIsBodyExpanded,
}: Props) {
    return (
        <Box
            sx={{
                marginTop: '16px',
                wordWrap: 'break-word',
                overflowWrap: 'anywhere',
            }}
        >
            <Typography
                variant="h4"
                sx={{
                    marginBottom: '16px',
                }}
            >
                Quote request response
            </Typography>
            <Typography variant="body2" color="text.primary">
                Dear {emailBody?.ClientName || ''},
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.primary', marginTop: '16px' }}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: emailBody?.LawyerDeclineReason || '',
                    }}
                ></div>
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.primary', marginTop: '16px' }}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: cleanHTML(emailBody?.EmailSignature || ''),
                    }}
                ></div>
            </Typography>
            <ShowLessButton
                isBodyExpanded={isBodyExpanded}
                bodyExpandedHandler={setIsBodyExpanded}
            />
        </Box>
    );
}
